import { Avatar } from '@mui/material'
import { get, isEmpty } from 'lodash'
import clsx from 'clsx'
import { LabraToolTipV2 } from '@labrav/react-components'

import type { UserState } from '../../../utils/hooks/useGetUsers'
import { useStyles } from './InvitedUsers.styles'

export const AvatarName = ({
  isAdmin,
  user,
  index,
}: {
  isAdmin: boolean
  user: UserState
  index: number
}) => {
  const { classes } = useStyles()
  const styles: string[] = [classes.user1, classes.user2, classes.user3]
  const toolTipTextForUser = !isEmpty((user?.name || '').trim())
    ? user?.name
    : user?.email
  return (
    <LabraToolTipV2 tooltipPlacement="bottom" description={toolTipTextForUser}>
      <Avatar
        className={clsx(
          classes.avatar,
          isAdmin ? classes.admin : styles[index]
        )}
        data-testid={`${isAdmin ? 'admin' : 'staff'}-members-name`}
      >
        {!isEmpty((user?.name || '').trim())
          ? get(user, 'name[0]', '').toUpperCase()
          : get(user, 'email[0]', '').toUpperCase()}
      </Avatar>
    </LabraToolTipV2>
  )
}
